import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const slot = css`
  & + &:before {
    inset-inline-start: ${spacing(2)};
    inset-inline-end: ${spacing(2)};
  }
`
export const body = css`
  position: relative;
`
export const extraBar = css`
  background: ${cssTheme.colors.amber.high};
`
export const closeButton = css`
  position: absolute;
  inset-block-end: 100%;
  margin-block-end: ${spacing(1)};
`
